import { Link, useParams } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { getDramaById, getRelatedDramas } from '@/mocks/dramas';
import DramaDetail from '@/pages/detail/components/DramaDetail';

export default function DetailPage() {
  const { id } = useParams<{ id: string }>();
  const drama = getDramaById(id);

  if (!drama) {
    return (
      <SiteLayout>
        <div className="w-full px-4 md:px-10 py-24 text-center">
          <span className="w-16 h-16 rounded-full bg-background-200 text-foreground-500 flex items-center justify-center mx-auto mb-5">
            <i className="ri-movie-2-line text-2xl"></i>
          </span>
          <h1 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 mb-3">
            未找到该剧集资料
          </h1>
          <p className="text-xs md:text-sm text-foreground-600 mb-7">
            这部剧集可能已下线，或者链接地址有误。
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/category/ethics"
              className="h-10 px-5 rounded-md bg-primary-700 text-background-50 text-xs md:text-sm flex items-center whitespace-nowrap hover:bg-primary-600 transition-colors"
            >
              浏览伦理剧集
            </Link>
            <Link
              to="/"
              className="h-10 px-5 rounded-md border border-background-300 text-foreground-700 text-xs md:text-sm flex items-center whitespace-nowrap hover:border-primary-300 transition-colors"
            >
              返回首页
            </Link>
          </div>
        </div>
      </SiteLayout>
    );
  }

  const related = getRelatedDramas(drama, 4);

  return (
    <SiteLayout>
      <DramaDetail drama={drama} related={related} />
    </SiteLayout>
  );
}